<template>
  <div>
    <div class="hero-head">

      <div class="row row-text">
        <div class="col s8 empty-col"></div>
        <div class="col s4 claim-col">

          <div class="claim-container">
            <div class="main-claim">
              <h1 class="style">
                <span style="color: #fff">{{ translation('text.home.one') }}</span>
              </h1>
            </div>
            <div class="line"></div>
            <div class="secondary-claim">
              <h2 class="style">
                <span class="light">{{ translation('text.hesd.one') }}</span><br />
                <span>{{ translation('testi.home.tow') }}</span>
              </h2>
            </div>

            <div class="store-links">
              <br /><br />
              <div class="row row-text">
                <div class="col s6 store-link-col">

                  <a href="https://itunes.apple.com/it/app/i-got-u-app/id541552068?l=it&amp;ls=1&amp;mt=8"
                    class="app-store-link" target="_blank">
                    <img class="img-fluid img-device" src="https://s3.us-east-1.amazonaws.com/igotu_prod/v2/mail/a.png"
                      alt="App Store">
                  </a>

                </div>
                <div class="col s6 store-link-col">
                  <a href="https://play.google.com/store/apps/details?id=it.sinoservizi.igotu" class="app-store-link" target="_blank">
                    <img class="img-fluid img-device" src="https://s3.us-east-1.amazonaws.com/igotu_prod/v2/mail/g.png"
                      alt="Paly Store">
                  </a>

                </div>

              </div>

            </div>

          </div>

        </div>
      </div>
    </div>

    <div class="corpo-pagina margine-home">

      <div class="row row-text margie-sup icon-row">
        <div class="col s1"></div>

        <div class="col s2 icon-box">
          <img src="@/assets/img/icons/list_icon_guest.png" class="title-icons" alt="List Guest" title="List Guest" />
          <br />
          <span class="home-title-box light">{{ translation('testi.home.tre') }}</span>
          <br />
          <span class="home-title-box">{{ translation('testi.home.gyestlist') }}</span>
        </div>

        <div class="col s2 icon-box">
          <img src="@/assets/img/icons/manage_icon_guest.png" class="title-icons" alt="Manage Guests"
            title="Manage Guests" />
          <br />
          <span class="home-title-box light">{{ translation('text.manage') }}</span>
          <br />
          <span class="home-title-box">{{ translation('text.guest.details') }}</span>
        </div>

        <div class="col s2 icon-box">
          <img src="@/assets/img/icons/send_mail.png" class="title-icons" alt="Send qr-code List Guest" title="Send qr-code List Guest" />
          <br />
          <span class="home-title-box light">{{ translation('home.logo.email.send') }}</span>
          <br />
          <span class="home-title-box">{{ translation('home.logo.email.send.second.row') }}</span>
        </div>

        <!-- div class="col s2 icon-box">
          <img src="@/assets/img/icons/manage_table.png" class="title-icons" alt="Manage Table Guests"
            title="Manage Guests" />
          <br />
          <span class="home-title-box light">{{ translation('home.logo.manage.table') }}</span>
          <br />
          <span class="home-title-box">{{ translation('home.logo.manage.table.row') }}</span>
        </div -->

        <div class="col s2 icon-box">
          <img src="@/assets/img/icons/analize_icon.png" class="title-icons" alt="Statistic List Guest" title="Statistic List Guest" />
          <br />
          <span class="home-title-box light">{{ translation('text.anaize.event') }}</span>
          <br />
          <span class="home-title-box">{{ translation('text.stats') }}</span>
        </div>

          <div class="col s2 icon-box">
          <img src="@/assets/img/icons/security.png" class="title-icons" alt="Security" title="Security" />
          <br />
          <span class="home-title-box light">{{ translation('logo.home.security.001') }}</span>
          <br />
          <span class="home-title-box">{{ translation('logo.home.security.002') }}</span>
        </div>

          <div class="col s2 icon-box">
          <img src="@/assets/img/icons/integrations.png" class="title-icons" alt="Integration Igotu" title="Integration Igotu" />
          <br />
          <span class="home-title-box light">{{ translation('logo.home.integrazione.001') }}</span>
          <br />
          <span class="home-title-box">{{ translation('logo.home.integrazione.002') }}</span>
        </div>

        <div class="col s1"></div>
      </div>

    </div>

    <div class="riga-slider slider-container-border">
      <div class="row row-text">
        <div class="col s12">
          <CarouselVue />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import translationStore from '@/store/translations'
import CarouselVue from '@/components/CarouselVue.vue'
import loadingStore from '@/store/loading'
import M from 'materialize-css'

export default {
  name: 'app',
  data () {
    return {
      translationStore: translationStore
    }
  },

  computed: {
    translation () {
      return translationStore.getters.traduzione
    }
  },

  async mounted () {
    document.addEventListener('DOMContentLoaded', function () {
      const elems = document.querySelectorAll('.slider')

      M.Slider.init(elems, {
        indicators: false,
        height: 1000,
        duration: 500,
        interval: 4000
      })
    })

    loadingStore.commit('setLoading', false)
  },
  components: {
    CarouselVue
  },

  methods: {},

  created () {
    loadingStore.commit('setLoading', false)
  }
}
</script>

<style>
/* ------------------------------------ */
/* 1. STILI BASE (DESKTOP FIRST) */
/* ------------------------------------ */

.hero-head {
  width: 100%;
  /* Usa 'cover' per adattare meglio l'immagine */
  background-image: url('@/assets/img/imgbig/img_hero.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center top;
  min-height: 65vh; /* Altezza visibile su desktop */
  padding-bottom: 50px;
}

.row-text {
  /* Assicura che le colonne si allineino su una riga */
  display: flex;
}

.claim-container {
  z-index: 10;
  width: 90%; /* Larghezza piena nella colonna */
  display: flex;
  justify-content: center;
  flex-direction: column;
}

/* Stili per le icone centrali (5 colonne su desktop) */
.icon-row {
  justify-content: center;
  align-items: flex-start;
}

.icon-box {
  text-align: center !important;
}

/* Margini e padding generali */
.margie-sup {
  margin-top: 7%;
}

.margine-home {
  margin-top: 15% !important;
}

h1.style {
  font-size: 2em;
  line-height: 1.5;
  margin-bottom: 0;
  font-weight: 400;
  color: white;
}

h2.style {
  font-size: 0.85em;
  line-height: 1.5;
  margin-bottom: 0;
  color: white;
}

.title-icons {
  max-width: 40px;
}

.img-device {
  width: 60% !important;
}

.light {
  font-weight: 300 !important;
}

/* ------------------------------------ */
/* 2. MEDIA QUERY - TABLET (Max 992px) */
/* ------------------------------------ */
@media screen and (max-width: 992px) {
  /* Hero Section */
  .hero-head {
    min-height: 60vh;
    background-color: #282828;
    background-position-x: 0;
    background-size: 80%;
  }

  /* Adattamento colonne Materialize/Grid:
     Da 8/4 a 6/6 su tablet per il claim */
  .row-text .empty-col {
    width: 50% !important;
  }
  .row-text .claim-col {
    width: 50% !important;
  }

  h1.style {
    font-size: 1.8em;
  }

  /* Icone Centrali: Da 5 colonne a 2 colonne per riga */
  .icon-row {
    flex-wrap: wrap; /* Permette il wrap delle colonne */
    justify-content: space-around; /* Distribuisce le colonne */
  }

  .icon-row .col.s1 {
    display: none; /* Rimuove le colonne vuote laterali */
  }

  /* Le 5 colonne s2 diventano il 45% (circa due per riga) */
  .icon-row .icon-box {
    width: 45% !important;
    margin-bottom: 30px;
    padding: 10px;
  }
}

/* ------------------------------------ */
/* 3. MEDIA QUERY - MOBILE (Max 600px) */
/* ------------------------------------ */
@media screen and (max-width: 600px) {

  /* Hero Section: Semplifica e centra */
  .hero-head {
    background-image: none; /* Rimuovi immagine per performance mobile */
    background-color: #282828;
    min-height: auto;
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .margine-home {
    margin-top: 5% !important;
  }

  /* Rimuovi colonne vuote e rendi il claim a piena larghezza */
  .row-text .empty-col {
    display: none;
  }

  .row-text .claim-col {
    width: 100% !important;
    padding: 0 20px;
  }

  .claim-container {
    align-items: center; /* Centra il contenuto del claim */
    text-align: center;
    width: 100%;
  }
  .secondary-claim{padding: 1%!important;}

  h1.style {
    font-size: 1.5em;
  }

  h2.style {
    font-size: 0.8em;
  }

  /* Icone Centrali: Una colonna per riga */
  .icon-row .icon-box {
    width: 100% !important; /* Piena larghezza */
    margin-bottom: 40px;
    padding: 0 20px;
  }

  /* Store Links: Metti le icone degli store una sotto l'altra (se troppo stretto) */
  .store-links .col.s6 {
    width: 100% !important;
    margin-bottom: 10px;
    text-align: center;
  }

  .img-device {
    width: 50% !important; /* Riduci la dimensione degli store link */
  }
}
</style>
